export const confidenceClass = (score) => {
    if (score === null || score === undefined) return 'confidence-none';
    if (score >= 90) return 'confidence-high';
    if (score >= 60) return 'confidence-medium';
    return 'confidence-low';
};

export const confidenceBadge = (score) =>
    score !== null && score !== undefined ? (
        <span className={`ocr-confidence-badge ${confidenceClass(score)}`}>
            {score}%
        </span>
    ) : null;

export const formatCurrency = (number) => {
    const formattedNumber = parseFloat(number || 0)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return `R$: ${formattedNumber}`;
};
